module.exports = __webpack_public_path__ + "img/cat_02.7e6cf422.jpg";